'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _actions = require('./ServerSide/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connector = (0, _reactRedux.connect)(null, function (dispatch) {
  return {
    set404: function set404() {
      return dispatch((0, _actions.setPageStatus)(404));
    }
  };
});

function NoRouteWrapper(NoRoute) {
  return connector(function (props) {
    var set404 = props.set404; // eslint-disable-line

    set404();
    return _react2.default.createElement(NoRoute, props);
  });
}

exports.default = NoRouteWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/NoRouteWrapper.js
// module id = 230
// module chunks = 0